<template>
  <div class="pl-root">
    <nav class="pl-nav">
      <RouterLink to="/" class="pl-nav-logo">
        <img src="/new-logo.png" class="pl-nav-logo-mark" alt="">
        <div class="pl-nav-logo-text-wrap">
          <span class="pl-nav-logo-text">Maths Eleven Plus</span>
          <span class="pl-nav-logo-slogan">Prepare with Precision. Succeed with Confidence.</span>
        </div>
      </RouterLink>
      <div class="pl-nav-links">
        <a href="/#features" class="pl-nav-link">Features</a>
        <RouterLink to="/worksheets" class="pl-nav-link">Worksheets</RouterLink>
        <a href="/#pricing" class="pl-nav-link">Pricing</a>
      </div>
      <template v-if="isAuthenticated">
        <RouterLink to="/parent/dashboard" class="pl-nav-cta">Dashboard →</RouterLink>
      </template>
      <template v-else>
        <div class="pl-nav-auth">
          <RouterLink to="/auth/login" class="pl-nav-signin">Sign in</RouterLink>
          <RouterLink to="/auth/register" class="pl-nav-cta">Begin Free</RouterLink>
        </div>
      </template>
    </nav>

    <main class="pl-main">
      <RouterView />
    </main>

    <SiteFooter />
  </div>
</template>

<script setup>
import { useAuth } from '@/composables/useAuth';
import SiteFooter from '@/components/layout/SiteFooter.vue';

const { isAuthenticated } = useAuth();
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,600;1,400&family=Jost:wght@400;500;700&display=swap');

.pl-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--mt-bg, #f8fafc);
}

.pl-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #0D1628;
  padding: 0 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;
  flex-shrink: 0;
}

.pl-nav-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  flex-shrink: 0;
}
.pl-nav-logo-mark { width: 36px; height: 36px; flex-shrink: 0; }
.pl-nav-logo-text-wrap { display: flex; flex-direction: column; gap: 1px; }
.pl-nav-logo-text {
  font-family: 'Cormorant Garamond', serif;
  font-size: 19px;
  font-weight: 600;
  color: white;
  letter-spacing: 0.02em;
  line-height: 1.1;
}
.pl-nav-logo-slogan {
  font-size: 9px;
  font-weight: 500;
  color: rgba(184,144,42,0.75);
  letter-spacing: 0.06em;
  line-height: 1.2;
}

.pl-nav-links { display: flex; gap: 36px; }
.pl-nav-link {
  color: rgba(255,255,255,0.55);
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.04em;
  transition: color 0.2s;
}
.pl-nav-link:hover { color: white; }

.pl-nav-auth { display: flex; align-items: center; gap: 20px; }
.pl-nav-signin {
  color: rgba(255,255,255,0.55);
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  transition: color 0.2s;
}
.pl-nav-signin:hover { color: white; }
.pl-nav-cta {
  background: #B8902A;
  color: #0D1628;
  padding: 9px 24px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  transition: background 0.2s;
}
.pl-nav-cta:hover { background: #d4a843; }

.pl-main { flex: 1; }

@media (max-width: 768px) {
  .pl-nav { padding: 0 24px; }
  .pl-nav-links { display: none; }
}
</style>
